import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const dateFormatter = {
  type: 'formatter',
  init(services, backendOptions, i18nextOptions) {}, // of you need some init stuff to be done...
  format(value, format, lng, options) {
    // do whatever you like here... and return the formatted string
    if (!format && value instanceof Date) {
      return value.toUTCString()
    }
    console.log("dateFormatter:"+value);
    if (format === 'DATE_SHORT') {
      if (!(value instanceof Date))
        value = new Date(value);
      return new Intl.DateTimeFormat(lng, { dateStyle: 'short' }).format(value);
    }
    else if (format === 'DATE_LONG') {
      if (!(value instanceof Date))
        value = new Date(value);
      return new Intl.DateTimeFormat(lng, { dateStyle: 'full' }).format(value);
    }
    else if (format === 'DATETIME_SHORT') {
      if (!(value instanceof Date))
        value = new Date(value);
      return new Intl.DateTimeFormat(lng, { dateStyle: 'short',timeStyle:'short' }).format(value);
    }
    else if (format === 'DATETIME_LONG') {
      if (!(value instanceof Date))
        value = new Date(value);
      return new Intl.DateTimeFormat(lng, { dateStyle: 'full',timeStyle:'short' }).format(value);
    }

    return value;
  },
  add(name, fc) {
    // handle adding a new format, if you need it
  },
  addCached(name, fc) {
    // handle adding a new cached format, if you need it
  }
}

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use(dateFormatter)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng:'tr-TR',
    fallbackLng: 'en-US',
    debug: true,
    interpolation: {
     escapeValue: false
    }
  });

export default i18n;